module.exports = function getStates() {
	const states = require("./states.json");
	return states;
};
